/* eslint-disable import/no-anonymous-default-export */
import BarChartIcon from "@material-ui/icons/BarChart";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ChatIcon from "@material-ui/icons/ChatOutlined";
import CodeIcon from "@material-ui/icons/Code";
import DashboardIcon from "@material-ui/icons/DashboardOutlined";
import ErrorIcon from "@material-ui/icons/ErrorOutline";
import FolderIcon from "@material-ui/icons/FolderOutlined";
import DashboardTwoToneIcon from "@material-ui/icons/DashboardTwoTone";
import GradeTwoTone from "@material-ui/icons/GradeTwoTone";
import ListAltIcon from "@material-ui/icons/ListAlt";
import LockOpenIcon from "@material-ui/icons/LockOpenOutlined";
import MailIcon from "@material-ui/icons/MailOutlined";
import PresentToAllIcon from "@material-ui/icons/PresentToAll";
import PeopleIcon from "@material-ui/icons/PeopleOutlined";
import PersonIcon from "@material-ui/icons/PersonOutlined";
import ReceiptIcon from "@material-ui/icons/ReceiptOutlined";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import ViewModuleIcon from "@material-ui/icons/ViewModule";

const periodos_rematriculacion = JSON.parse(sessionStorage.getItem("rematriculaciones"));

var iconsMap = {
  BarChartIcon: BarChartIcon,
  CalendarTodayIcon: CalendarTodayIcon,
  ChatIcon: ChatIcon,
  CodeIcon: CodeIcon,
  DashboardIcon: DashboardIcon,
  ErrorIcon: ErrorIcon,
  FolderIcon: FolderIcon,
  DashboardTwoToneIcon: DashboardTwoToneIcon,
  GradeTwoTone: GradeTwoTone,
  ListAltIcon: ListAltIcon,
  LockOpenIcon: LockOpenIcon,
  MailIcon: MailIcon,
  PresentToAllIcon: PresentToAllIcon,
  PeopleIcon: PeopleIcon,
  PersonIcon: PersonIcon,
  ReceiptIcon: ReceiptIcon,
  SettingsIcon: SettingsIcon,
  ViewModuleIcon: ViewModuleIcon,
};

var mis_inscripciones_content_item = [
  {
    "label": "Inscripción a Materia",
    "description": "Proceso de inscripciones para el cursado de materias",
    "to": "/InscripcionesCursada"
  },
  {
    "label": "Inscripciones a Examen",
    "description": "Proceso de inscripciones a exámenes",
    "to": "/InscripcionesExamenes"
  },
  {
    "label": "Inscripciones a Carrera",
    "description": "Proceso de inscripciones a carrera",
    "to": "/InscripcionesCarrera"
  },
];

if (periodos_rematriculacion && periodos_rematriculacion.length > 0) {    
  mis_inscripciones_content_item.push(
    {
      "label": "Formulario Norte",      
      "description": "Proceso de reinscripción",
      "to": "/FormularioNorte"
    }
  )
}

var items = [
    {
      "label": "Pantalla Principal",
      "icon": "FolderIcon",
      "description": "Volver a la pantalla de inicio",
      "to": "/"
    } ,
    {
      "label": "Mis inscripciones",
      "icon": "DashboardTwoToneIcon",
      "content": mis_inscripciones_content_item
    },
    {
      "label": "Pautas Administrativas",
      "icon": "ListAltIcon",
      "to": "/PautasAdministrativas"
    } 
  ];

console.log(items);

// esto lo haria function y que retorne el div con los SidebarMenu directamente
export default [
  {
    label: "MENU DE OPERACIONES",
    content: JSON.parse(
     JSON.stringify(items),
      (key, value) => {
        if (key === "icon") {
          return iconsMap[value];
        } else {
          return value;
        }
      },
    ),
  },
];
